/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import type { MouseEventHandler, PropsWithChildren } from 'react';
import React from 'react';
import cx from 'clsx';

import type { StyleableProps } from '~/types';

export function Chip({
  style = {},
  className,
  children,
  onClick,
}: PropsWithChildren &
  StyleableProps & { onClick?: MouseEventHandler<HTMLSpanElement> }) {
  return (
    <span
      className={cx(
        'px-12 py-[5px] text-accent typo-paragraph100-semibold bg-blue-100 rounded-16',
        className,
      )}
      role="presentation"
      style={style}
      onClick={onClick}
    >
      {children}
    </span>
  );
}

export default Chip;
